const imgAlt = (url: string) => {
    // Extract alt from fielname
    const regex = /.+\/(.+)\.[a-z]+$/;
    const match = regex.exec(url);

    if (match && match[1]) {
        const rawFileName = match[1]; 
        const fileNameParts = rawFileName.split(/[_]/g);

        return fileNameParts.slice(0, fileNameParts.length - 1).join(' '); // remove the uid added by cloudinary
    } else {
        return '';
    }
}

export default imgAlt;